<template>
  <filter-summary
    icon="item"
    title="商品分類"
    :scroll-to-id="scrollToId"
    v-on="$listeners"
    :errors="errors"
  >
    <div>
      {{ clusterModeLabel }}
    </div>
    <div>
      <span v-if="excludeNonActive">実績なしを除外する</span>
    </div>
    <div v-if="selectMode !== 'item-group-file'">{{ count }}{{ label }}</div>
    <div v-else>{{ filename }}</div>
    <div v-if="includeSiblings">同{{ categoryLabel }}の商品も含める</div>
  </filter-summary>
</template>

<script>
import FilterSummary from '@/components/FilterSummary.vue'

/**
 * 商品分類の分析条件サマリ
 */
export default {
  components: { FilterSummary },
  props: {
    scrollToId: String,
    clusterMode: String,
    company: String,
    excludeNonActive: Boolean,
    includeSiblings: Boolean,
    selectMode: String,
    itemCategoryLevel: Number,
    itemGroupFile: File,
    item: Object,
    category: Object,
    errors: {
      type: Array,
    },
  },
  computed: {
    clusterModeLabel() {
      switch (this.clusterMode) {
        case 'item':
          return '単品でクラスター'
        case 'category':
          return '分類でクラスター'
        default:
          throw new Error(`Unknown cluster mode: ${this.clusterMode}`)
      }
    },
    count() {
      if (this.clusterMode === 'item') {
        if (this.selectMode === 'category') {
          return this.item.categories.length
        } else if (this.selectMode === 'item') {
          return this.item.items.length
        }
      } else if (this.clusterMode === 'category') {
        return this.category.categories.length
      }
      return undefined
    },
    label() {
      if (this.clusterMode === 'item') {
        if (this.selectMode === 'category') {
          return '分類'
        } else if (this.selectMode === 'item') {
          return '商品'
        }
      } else if (this.clusterMode === 'category') {
        return '分類'
      }
      return undefined
    },
    filename() {
      if (!this.itemGroupFile) {
        return undefined
      }
      return this.itemGroupFile.name
    },
    categoryLabel() {
      if (!this.company) {
        return 'no company'
      }
      const levels = this.$store.state.itemCategoryLevels[this.company]
      const level = levels.filter(c => c.level === this.itemCategoryLevel)
      if (!level.length) {
        throw new Error('no item category level found')
      }
      return level[0].name
    },
  },
}
</script>
